import React from 'react';
import SelectNested from "../../../elements/SelectNested";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";

const PositionTraining = ({index, state, trainingsList, onRemove}) => {
  const propertyName = `requiredTrainings[${index}]`;

  return (
    <div className="position-requirement-row">
      <div className="position-requirement-select">
        <SelectNested
          propertyName={propertyName}
          state={state}
          itemsList={trainingsList}
          displayNames={["name"]}
          showInput={false}
          showDelete={false}
          useId={false}
        />
      </div>
      <button
        type="button"
        className="btn btn-outline-danger position-requirement-remove"
        onClick={(e) => {
          e.preventDefault();
          onRemove();
        }}
        aria-label="Usuń wymagane szkolenie"
        title="Usuń"
      >
        <FontAwesomeIcon icon={faTrashAlt}/>
      </button>
    </div>
  );
};

export default PositionTraining;
